import React from 'react';
import { SettingsHelper } from '../../utils';
import type { WidgetSettings } from '../../typings/configuration.types';
import { ExpressCheckout } from './ExpressCheckout';

interface IEmbedProps {
    settings: WidgetSettings;
}

interface IEmbedState {
    settings: WidgetSettings;
}

class Embed extends React.Component<IEmbedProps, IEmbedState> {
    observer: MutationObserver | null = null;

    totalBasketPriceElementId: string | null = null;

    dataCartTotalAttrName = 'data-cart-total';

    isComponentMounted = false;

    constructor(props: IEmbedProps) {
        super(props);
        this.state = {
            settings: props.settings,
        };

         
        SettingsHelper.initializeApiBasePathAndLocale(props.settings);
        this.setupObserver(props.settings);
    }

    componentDidMount(): void {
        this.isComponentMounted = true;
    }

    setupObserver(settings: WidgetSettings) {
        
        const targetElementId = settings.totalBasketPriceParentElementId;
        this.totalBasketPriceElementId = settings.totalBasketPriceElementId;

        if (targetElementId) {
            const element = document.getElementById(targetElementId);
            if (!element) {
                console.error(`No element found with id: ${targetElementId}`);
                return;
            }

            const basketTotalElement = this.findBasketTotalElementInParent(element);
            this.extractBasketTotalFromElement(basketTotalElement);

            this.observer = new MutationObserver(this.observerCallback);
            this.observer.observe(element, {
                attributes: true,
                childList: true,
                subtree: true,
            });
        } else {
            console.error(`totalBasketPriceParentElementId was not defined in the properties`);
        }
    }

    observerCallback = (mutations: MutationRecord[]) => {
        mutations.forEach((mutation) => {
            const targetElement = mutation.target as HTMLElement;
            
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                const basketTotalElement = this.findBasketTotalElementInParent(targetElement);
                this.extractBasketTotalFromElement(basketTotalElement);
            }
            if (mutation.type === 'attributes' && mutation.attributeName === this.dataCartTotalAttrName) {
                this.extractBasketTotalFromElement(targetElement);
            }
        });
    };

    findBasketTotalElementInParent(parent: HTMLElement | null): HTMLElement | null {
        if (!parent) return null;

        const matchingChild = parent.querySelector(`#${this.totalBasketPriceElementId}`);
        return matchingChild ? (matchingChild as HTMLElement) : null;
    }

    extractBasketTotalFromElement(element: HTMLElement | null) {
        if (!element) {
            return;
        }

        const attr = element.attributes.getNamedItem(this.dataCartTotalAttrName);
        if (attr) {
            const basketTotalNumber = Number(attr.value);
            if (!Number.isNaN(basketTotalNumber)) {
                console.log('New basket total: ', basketTotalNumber);
                const { settings: currentSettings } = this.state;
                const newProps = {
                    settings: {
                        ...currentSettings,
                        basketTotal: basketTotalNumber,
                    },
                };
                this.updateWithNewProps(newProps);
            }
        } else {
            console.error(`Attribute ${this.dataCartTotalAttrName} was not definted for the element!`);
        }
    }

    updateWithNewProps(newProps: IEmbedProps) {
         
        if (this.state.settings !== newProps.settings && this.isComponentMounted) {
            this.setState({ settings: newProps.settings });
        }
    }

    disconnectObserver() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    render() {
        const { settings } = this.state;
        return <ExpressCheckout settings={settings} />;
    }
}

export default Embed;
